"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

var _KeyPair = _interopRequireDefault(require("../model/KeyPair"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
* Key service.
* @module api/KeyApi
* @version 0.4.1
*/
var KeyApi = /*#__PURE__*/function () {
  /**
  * Constructs a new KeyApi. 
  * @alias module:api/KeyApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function KeyApi(apiClient) {
    _classCallCheck(this, KeyApi);

    this.apiClient = apiClient || _ApiClient.default.instance;
  }
  /**
   * Callback function to receive the result of the postKeyNew operation.
   * @callback module:api/KeyApi~postKeyNewCallback
   * @param {String} error Error message, if any.
   * @param {module:model/KeyPair} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * 生成一个新的密钥对并返回
   * 生成一个新的密钥对, 将其保存到 /keys 下, 并返回生成的密钥对内容, 如果同名文件已存在则返回错误
   * @param {String} name 密钥名, 必须唯一
   * @param {Object} opts Optional parameters
   * @param {String} opts.password 密码
   * @param {String} opts.cipher 加密算法, 支持 rsa/dsa/ecdsa/ed25519, 默认为 rsa
   * @param {module:api/KeyApi~postKeyNewCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link module:model/KeyPair}
   */


  _createClass(KeyApi, [{
    key: "postKeyNew",
    value: function postKeyNew(name, opts, callback) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'name' is set

      if (name === undefined || name === null) {
        throw new Error("Missing the required parameter 'name' when calling postKeyNew");
      }

      var pathParams = {};
      var queryParams = {
        'name': name,
        'password': opts['password'],
        'cipher': opts['cipher']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _KeyPair.default;
      return this.apiClient.callApi('/key/new', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
  }]);

  return KeyApi;
}();

exports.default = KeyApi;